"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.usePopover = exports.Popover = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_popper_1 = require("react-popper");
var component_library_1 = require("@kaizen/component-library");
var close_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/close.icon.svg"));
var typography_1 = require("@kaizen/typography");
var classMappers_1 = require("./classMappers");
var Popover_module_scss_1 = __importDefault(require("./Popover.module.scss"));
// Sync with styles.scss
var arrowWidth = 14;
var arrowHeight = 7;
/**
 * {@link https://cultureamp.design/components/popover/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-popover--default-kaizen-site-demo Storybook}
 */
var Popover = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.placement, placement = _c === void 0 ? "top" : _c, _d = _a.size, size = _d === void 0 ? "small" : _d, heading = _a.heading, _e = _a.dismissible, dismissible = _e === void 0 ? false : _e, onClose = _a.onClose, _f = _a.singleLine, singleLine = _f === void 0 ? false : _f, customIcon = _a.customIcon, referenceElement = _a.referenceElement, automationId = _a.automationId, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["children", "variant", "placement", "size", "heading", "dismissible", "onClose", "singleLine", "customIcon", "referenceElement", "automationId", "classNameOverride"]);
    var _g = (0, react_1.useState)(null), popperElement = _g[0], setPopperElement = _g[1];
    var _h = (0, react_1.useState)(null), arrowElement = _h[0], setArrowElement = _h[1];
    var _j = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    // Ensures that the arrow doesn't go too far to the left or right
                    // of the tooltip.
                    padding: arrowWidth / 2 + 10
                }
            },
            {
                name: "offset",
                options: {
                    offset: [0, arrowHeight + 6]
                }
            },
            {
                name: "preventOverflow",
                options: {
                    // Makes sure that the popover isn't flush up against the end of the
                    // viewport
                    padding: 8,
                    altAxis: true,
                    altBoundary: true,
                    tetherOffset: 50
                }
            },
            {
                name: "flip",
                options: {
                    padding: 8,
                    altBoundary: true,
                    fallbackPlacements: ["left", "top", "bottom", "right"]
                }
            },
        ],
        placement: placement
    }), popperStyles = _j.styles, attributes = _j.attributes;
    return (react_1["default"].createElement("div", __assign({ ref: setPopperElement, style: popperStyles.popper }, attributes.popper, { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].root, (0, classMappers_1.mapSizeToClass)(size), classNameOverride), "data-automation-id": automationId }, restProps),
        react_1["default"].createElement("div", { className: (0, classMappers_1.mapVariantToBoxClass)(variant) },
            heading && (react_1["default"].createElement("div", { className: Popover_module_scss_1["default"].header },
                variant !== "default" && (react_1["default"].createElement("span", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].icon, (0, classMappers_1.mapVariantToIconClass)(variant)) },
                    react_1["default"].createElement(component_library_1.Icon, { role: "presentation", icon: customIcon ? customIcon : (0, classMappers_1.mapVariantToIcon)(variant) }))),
                react_1["default"].createElement(typography_1.Heading, { variant: "heading-6", classNameOverride: Popover_module_scss_1["default"].singleLine }, heading),
                dismissible && (react_1["default"].createElement("button", { className: Popover_module_scss_1["default"].close, onClick: onClose, type: "button", "aria-label": "close" },
                    react_1["default"].createElement(component_library_1.Icon, { role: "presentation", icon: close_icon_svg_1["default"] }))))),
            react_1["default"].createElement(typography_1.Paragraph, { variant: "small", classNameOverride: (0, classnames_1["default"])(Popover_module_scss_1["default"].container, (0, classMappers_1.mapLineVariant)(singleLine)) }, children)),
        react_1["default"].createElement("div", { ref: setArrowElement, style: popperStyles.arrow, className: Popover_module_scss_1["default"].arrowWrapper },
            react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Popover_module_scss_1["default"].arrow, (0, classMappers_1.mapArrowVariantToClass)(variant)) }))));
};
exports.Popover = Popover;
exports.Popover.displayName = "Popover";
/**
 * How to use:
 *
 * const [referenceElementRef, Popover] = usePopover()
 *
 * return (<>
 *   <button ref={referenceElementRef}>
 *     Hello world
 *   </button>
 *   <Popover>Hello world</Popover>
 * </>)
 *
 * The purpose of this hook is to abstract away some of the awkwardness with the
 * requirement of passing in refs with popper. We need to use `useState` instead
 * of `useRef`, which may not be immediately intuitive.
 *
 * The popper documentation to help provide more context:
 *   https://popper.js.org/react-popper/v2/hook/
 */
var usePopover = function () {
    var _a = (0, react_1.useState)(null), referenceElement = _a[0], setReferenceElement = _a[1];
    // I guess the problem with this pattern, is that every time referenceElement
    // changes, a brand new component is generated, which would be bad for memoization.
    // In this situation however, the value is rarely going to change, and
    // popovers aren't going to include content with expensive render times.
    var PopoverWithRef = (0, react_1.useMemo)(
    // eslint-disable-next-line react/display-name
    function () { return function (props) {
        return referenceElement ? (react_1["default"].createElement(exports.Popover, __assign({}, props, { referenceElement: referenceElement }))) : null;
    }; }, [referenceElement]);
    return [setReferenceElement, PopoverWithRef];
};
exports.usePopover = usePopover;
//# sourceMappingURL=Popover.js.map